if (!customElements.get('flip-card')) {
  class FlipCard extends HTMLElement {
    constructor() {
      super();
      this.onLinkClick = this.onLinkClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.link = this.querySelector('.flip-card__link');
      if (!this.link) return;

      // Tap/click-to-open, for every input type (2026-07-26 fix — this used
      // to be skipped entirely whenever `window.matchMedia('(hover: hover)
      // and (pointer: fine)')` matched true at the moment the element was
      // constructed. That's meant to detect "real mouse" devices so they
      // rely on plain CSS :hover instead, but it's a one-time snapshot: on
      // real phones where that check misfires (some in-app/WebView
      // browsers report hover capability inconsistently) the card never
      // got a working tap interaction at all — reported as "the book-like
      // behavior doesn't work on mobile". Listeners are now always
      // attached, and onLinkClick below checks the card's OWN current
      // hover/focus state at the moment of the click instead, which works
      // correctly regardless of device: a mouse user who already hovered
      // the card open just navigates on click (:hover already true), while
      // a touch tap (no real :hover) opens on the first tap and navigates
      // on the second, same as before.
      this.link.addEventListener('click', this.onLinkClick);
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    onLinkClick(event) {
      var alreadyRevealed =
        this.classList.contains('is-open') ||
        this.matches(':hover') ||
        this.matches(':focus-within');

      if (!alreadyRevealed) {
        event.preventDefault();
        document.querySelectorAll('flip-card.is-open').forEach((card) => {
          if (card !== this) card.classList.remove('is-open');
        });
        this.classList.add('is-open');
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.classList.remove('is-open');
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.classList.remove('is-open');
      }
    }
  }

  customElements.define('flip-card', FlipCard);
}
